import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useRole } from "../../context/RoleContext";
import { verifyIsAuthenticated } from "../../common/getValidToken";
import TrialGuard from "../trialGuard/TrialGuard";
import { normalizeRole } from "../../utils/roleUtils";

export default function ProtectedRoute(props: { children?: React.ReactNode }) {
  const { setRole } = useRole();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const checkTokenAndRole = async () => {
      const authState = await verifyIsAuthenticated();

      if (authState) {
        const storedRole = localStorage.getItem("userRole");
        if (storedRole) {
          const userType = normalizeRole(storedRole);
          localStorage.setItem("userRole", userType);
          setRole(userType);
        }
        setIsAuthenticated(true);
      } else {
        setRole("");
        setIsAuthenticated(false);
      }
    };

    checkTokenAndRole();
  }, [location.pathname, setRole]);

  if (isAuthenticated === null) {
    return null;
  }

  if (isAuthenticated) {
    return (
      <TrialGuard>
        <Outlet />
      </TrialGuard>
    );
  }

  return <Navigate to={`/signin`} replace />;
}
